// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Tabs__tabs--2z5Ny","tabWrapper":"Tabs__tabWrapper--dfCH1"};